export class PriceNhiDrugcodes {
    public static readonly 居護整合醫令_05301C = "05301C";
    public static readonly 居護整合醫令_05302C = "05302C";
    public static readonly 居護整合醫令_05303C = "05303C";
    public static readonly 居護整合醫令_05304C = "05304C";
    public static readonly 居護整合醫令_05305C = "05305C";
    public static readonly 居護整合醫令_05306C = "05306C";
    public static readonly 居護整合醫令_05307C = "05307C";
    public static readonly 居護整合醫令_05308C = "05308C";
    public static readonly 居護整合醫令_05312C = "05312C";
    public static readonly 居護整合醫令_05313C = "05313C";
    public static readonly 居護整合醫令_05314C = "05314C";
    public static readonly 居護整合醫令_05315C = "05315C";
    public static readonly 居護整合醫令_05316C = "05316C";
    public static readonly 居護整合醫令_05321C = "05321C";
    public static readonly 居護整合醫令_05322C = "05322C";
    public static readonly 居護整合醫令_05324C = "05324C";
    public static readonly 居護整合醫令_05325C = "05325C";
    public static readonly 居護整合醫令_05326C = "05326C";
    public static readonly 居護整合醫令_05327C = "05327C";
    public static readonly 居護整合醫令_05336C = "05336C";
    public static readonly 居護整合醫令_05337C = "05337C";
    public static readonly 居護整合醫令_05338C = "05338C";
    public static readonly 居護整合醫令_05339C = "05339C";
    public static readonly 居護整合醫令_05340C = "05340C";
    public static readonly 居護整合醫令_05341C = "05341C";
    public static readonly 居護整合醫令_P5401C = "P5401C";
    public static readonly 居護整合醫令_P5402C = "P5402C";
    public static readonly 居護整合醫令_P5403C = "P5403C";
    public static readonly 居護整合醫令_P5404C = "P5404C";
    public static readonly 居護整合醫令_P5405C = "P5405C";
    public static readonly 居護整合醫令_P5406C = "P5406C";
    public static readonly 居護整合醫令_P5408C = "P5408C";
    public static readonly 居護整合醫令_P5409C = "P5409C";
    public static readonly 居護整合醫令_P5411C = "P5411C";
    public static readonly 居護整合醫令_P5412C = "P5412C";
    public static readonly 居護整合醫令_P5413C = "P5413C";
    public static readonly 康家整合醫令_05401C = "05401C";
    public static readonly 康家整合醫令_05402C = "05402C";
    public static readonly 康家整合醫令_05403C = "05403C";
    public static readonly 康家整合醫令_05404C = "05404C";
    public static readonly 康家整合醫令_05405C = "05405C";
    public static readonly 康家整合醫令_05406C = "05406C";

    public static readonly 居整AllstdCodes: string[] = [
        "05301C", "05302C", "05303C", "05304C", "05305C", "05306C", "05307C", "05308C", 
        "05312C", "05313C", "05314C", "05315C", "05316C", "05321C", "05322C", "05324C", 
        "05325C", "05326C", "05327C", "05336C", "05337C", "05338C", "05339C", "05340C", 
        "05341C", "P5401C", "P5402C", "P5403C", "P5404C", "P5405C", "P5406C", "P5408C", 
        "P5409C", "P5411C", "P5412C", "P5413C"
    ];
        public static readonly 康家AllStdCodes: string[] = [
        "05401C", "05401C", "05403C", "05404C", "05405C", "05406C"
    ];
}
